import Views from '../../views/entry/athleteUser/AthleteUserViews';
import getInitialStateOmeRoute from './GetInitialStateOmeRoute';
import getInitialStateMeetRoute from './GetInitialStateMeetRoute';
import { contactsIsComplete } from './LeftNavValidation';

const getCredentials = (viewName, route, orgUnitAthleteEntryInfoStateObjData) => {
  const isCurrent = viewName === Views.OME_MEET_CONTACTS;

  const isComplete = contactsIsComplete(orgUnitAthleteEntryInfoStateObjData);

  const arePrerequisitesDone = true;

  const item = route === '' ? getInitialStateOmeRoute(Views.OME_MEET_CONTACTS) : getInitialStateMeetRoute(Views.OME_MEET_CONTACTS);

  return {
    ...item,
    isCurrent,
    isComplete,
    arePrerequisitesDone
  };
};

export default getCredentials;